import type { Comment } from "@brookbush/types";

interface CommentWrapperProps {
	comment: Comment;
	children: React.ReactNode;
}

const CommentWrapper = ({ children, comment }: CommentWrapperProps) =>
	comment.replyToId ? <div className="ml-5">{children}</div> : <>{children}</>;

export default CommentWrapper;
